import React, { useEffect, useMemo } from "react";
import { getPharmacyInfoLocal, searchEsProduct } from "../../../api";
import { DistributorInventoryModel, ICreateOrderPayload, ProductModel, ProductViewModel } from "../../../models";
import { formatPrice, useAsync, useQuery } from "../../../utils";
import { Header } from "../../shared";
import { Modal } from 'react-bootstrap'
import useViewModel from "../../../viewModel/base";
import { useHistory } from "react-router";
import distributorApi from "../../../api/distributor";
import { useRecoilValue } from "recoil";
import { accountDataState } from "../../../recoil/account";
import { pharmacyDataState } from "../../../recoil/pharmacy";
import CurrencyInput from "react-currency-input-field";
import distributorVM from "../../../viewModel/distributor";

const DistributorInventoryDetail = () => {
    const query = useQuery();
    const history = useHistory();
    const distributorInventoryId: number = parseInt(query.get("distributorInventoryId") || '')
    const distributorId: number = parseInt(query.get("distributorId") || '')
    const productId: string = query.get("productId") || ''
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN')
            return accountInfo.doctor.mId
    }, [accountInfo])

    const searchProductAsync = useAsync(searchEsProduct)
    const { execute: getDistributorInventories, value: distributorInventories, status: getDistributorInventoriesStatus } = useAsync(distributorApi.getDistributorInventories)
    const { execute: createOrder, status: createOrderStatus, value: createOrderRes } = useAsync(distributorApi.createOrder)

    const account = useRecoilValue(accountDataState)

    const viewModel = useViewModel({
        showSuccess: false,
        selectedAmount: '1',
        selectedPkg: {} as DistributorInventoryModel
    })

    useEffect(() => {
        getDistributorInventories({
            include: [{ relation: "mDistributor" }],
            where: {
                and: [
                    { mProductId: productId },
                    { mDistributorId: distributorId }
                ]
            }
        }, adminId)
    }, [])

    useEffect(() => {
        if (!distributorInventories || !distributorInventoryId) return

        const selectedPkg = distributorInventories.find(item => item.mId === distributorInventoryId)

        if (selectedPkg) {
            viewModel.updateData({ selectedPkg })
        }
    }, [distributorInventoryId, distributorInventories])

    useEffect(() => {
        if (!productId) return
        searchProductAsync.execute(getQuery(productId));
    }, [productId])

    const getQuery = (productId: string) => {
        return {
            query: {
                match: {
                    _id: productId,
                },
            },
        };
    };

    const product: ProductModel = useMemo(() => {
        const _product = searchProductAsync.value?.data[0];

        return {
            ..._product,
        };
    }, [searchProductAsync.value])

    const productVM = new ProductViewModel(product);

    const handleCreateOrder = () => {
        const pharmacy = getPharmacyInfoLocal()
        const payload = {
            mPharmacyId: pharmacy?.pharmacyId,
            mPharmacistId: parseInt(account?.doctor?.mId || ''),
            items: [
                {
                    mInventoryId: viewModel.data.selectedPkg?.mId,
                    mProductId: product._id,
                    mProductName: product.name,
                    mProductImage: product.imageUrls && product.imageUrls[0],
                    mPkgPrice: viewModel.data.selectedPkg?.mPrice,
                    mDiscountPrice: viewModel.data.selectedPkg?.mDiscountPrice,
                    mDiscountStatus: viewModel.data.selectedPkg?.mDiscountStatus,
                    mPkgName: viewModel.data.selectedPkg?.mPkgName,
                    mTotalItems: parseInt(viewModel.data.selectedAmount),
                    mDiscountHtml: viewModel.data.selectedPkg?.mDiscountHtml || undefined
                }
            ]
        }

        createOrder(payload).then(res => {
            viewModel.updateData({ showSuccess: true })
        })
    }

    return <>
        <Header
            title="Sản phẩm"
            backTo="/distributor-dashboard?tab=inventories"
        />
        <div id="main">
            <div className="container">
                <div className="product-summary d-flex">
                    <div className="product-thumb">
                        <img src={product.imageUrls && product.imageUrls[0]} className="img-fluid" width={75} />
                    </div>
                    <div>
                        <p><strong>{viewModel.data.selectedPkg?.mProductName}</strong></p>
                        <strong className="txt-orange">
                            {formatPrice(distributorVM.getDitributorInvPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ/ {viewModel.data.selectedPkg?.mPkgName}
                        </strong>
                        {
                            !!distributorVM.getDitributorInvBeforeDiscountPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus) &&
                            <div className='d-flex w-100 align-items-center'>
                                <div style={{ color: '#707070', textDecoration: 'line-through', whiteSpace: 'nowrap', fontSize: 13 }}>
                                    {formatPrice(distributorVM.getDitributorInvBeforeDiscountPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ/ {viewModel.data.selectedPkg?.mPkgName}
                                </div>
                                <div className='ml-2' style={{ padding: 5, backgroundColor: '#fdeee2', fontSize: 11, borderRadius: 5 }}>
                                    Giảm chiết khấu
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="discount-html pb-3">
                    <div dangerouslySetInnerHTML={{ __html: viewModel.data.selectedPkg?.mDiscountHtml ? viewModel.data.selectedPkg.mDiscountHtml : '' }} />
                </div>
                <div className="product-actions d-flex align-items-center mb-3">
                    <div className="quality">
                        <div className="group-input d-flex">
                            <button
                                onClick={() => {
                                    if (parseInt(viewModel.data.selectedAmount) === 1) return
                                    viewModel.updateData({ selectedAmount: (parseInt(viewModel.data.selectedAmount) - 1).toString() })
                                }}
                                className={`${parseInt(viewModel.data.selectedAmount) === 1 && "disable"}`}
                            ><span className="fa fa-minus">-</span></button>
                            <CurrencyInput
                                groupSeparator="."
                                decimalSeparator=","
                                onValueChange={(value) => {
                                    viewModel.updateData({ selectedAmount: value || '' })
                                }}
                                className="input"
                                style={{ minWidth: 75 }}
                                value={viewModel.data.selectedAmount}
                                onBlur={(e) => {
                                    if (!e.target.value || e.target.value === '0') {
                                        viewModel.updateData({ selectedAmount: '1' })
                                    }
                                }}
                            />
                            <button
                                onClick={() => {
                                    viewModel.updateData({ selectedAmount: (parseInt(viewModel.data.selectedAmount) + 1).toString() })
                                }}
                            ><span className="fa fa-plus">+</span></button>
                        </div>
                    </div>
                    <div className="ml-3">
                        <select
                            className="form-control smaller"
                            style={{ height: 32 }}
                            onChange={(e) => {
                                const selectedPkg = distributorInventories.find(item => item.mId === parseInt(e.target.value))
                                viewModel.updateData({ selectedPkg })
                            }}
                        >
                            {
                                distributorInventories?.map(item => {
                                    return <option
                                        key={item.mId}
                                        value={item.mId}
                                    >
                                        {item.mPkgName}
                                    </option>
                                })
                            }
                        </select>
                    </div>
                    <div className="ml-auto d-flex txt-orange" style={{ whiteSpace: 'nowrap' }}>
                        {formatPrice(+viewModel.data.selectedAmount * distributorVM.getDitributorInvPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ
                    </div>
                </div>
                <div className="product-detail-content pb-4">
                    <p>Nhà phân phối: {viewModel.data.selectedPkg?.mDistributor?.mName}</p>
                    <div className="product-detail">
                        <div>
                            {
                                productVM.getViewDetailInfo().map((info, index) => {
                                    return <div key={index}>
                                        <b>{index + 1}. {info.title}: </b>
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: info.value }} />
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div style={{ height: 72 }}>
                    <div className="fixed-button d-flex justify-content-between">
                        <a className="btn btn-block" onClick={() => {
                            handleCreateOrder()
                        }}>ĐẶT HÀNG</a>
                    </div>
                </div>
            </div>
        </div>

        <Modal show={viewModel.data.showSuccess} onHide={() => viewModel.updateData({ showSuccess: false })}>
            <div className="modal-header">
                <img src="./images/check.svg" alt="Thành công" className="img-fluid" width={48} />
            </div>
            <div className="modal-body">
                <h3>Đặt hàng thành công!</h3>
            </div>
            <div className="modal-footer d-block px-4">
                <a onClick={() => { history.push('/distributor-dashboard?tab=inventories') }} className="btn btn-block mw-100">QUAY LẠI CHỌN SẢN PHẨM</a>
                <br />
                <a onClick={() => { history.push(`/distributor-order-info?orderId=${createOrderRes?.mId}`) }} className="btn btn-block btn-border mw-100 line-height-18">XEM ĐƠN HÀNG</a>
            </div>
        </Modal>

    </>
}

export default DistributorInventoryDetail